import React from 'react';
import { Link } from 'react-router-dom';

function Podcast() {
  return (
    <div className="podcast-content">
      <div className="tiles-container">
        <Link to="/podcast/category" className="tile category-tile">
          <article>
            <div className="tile-icon">📚</div>
            <h3 className="tile-title">Genre</h3>
            <p className="tile-description">Browse and manage content Genre</p>
          </article>
        </Link>

        <Link to="/podcast/list" className="tile podcast-tile">
          <article>
            <div className="tile-icon">🎧</div>
            <h3 className="tile-title">Podcast</h3>
            <p className="tile-description">Access podcast content and episodes</p>
          </article>
        </Link>
        <Link to="/support/podcast" className="tile support-tile">
          <article>
            <div className="tile-icon">💬</div>
            <h3 className="tile-title">Support</h3>
            <p className="tile-description">Track and resolve support tickets</p>
          </article>
        </Link>
        <Link to="/podcast/exam-info" className="tile exam-info-tile">
          <article>
            <div className="tile-icon">📋</div>
            <h3 className="tile-title">Exam Info</h3>
            <p className="tile-description">Manage PSC exam details, dates & syllabi</p>
          </article>
        </Link>
        <Link to="/podcast/requests-ratings" className="tile">
          <article>
            <div className="tile-icon">⭐</div>
            <h3 className="tile-title">Requests &amp; Ratings</h3>
            <p className="tile-description">View user requests and app ratings</p>
          </article>
        </Link>
        <Link to="/podcast-subscriptions" className="tile">
          <article>
            <div className="tile-icon">💳</div>
            <h3 className="tile-title">Subscriptions</h3>
            <p className="tile-description">Manage subscribers, cancellations and refunds</p>
          </article>
        </Link>
        {/* <Link to="/podcast/analytics" className="tile empty-tile">
          <article>
            <div className="tile-icon">📊</div>
            <h3 className="tile-title">Trends & Usage</h3>
            <p className="tile-description">Track podcast performance insights</p>
          </article>
        </Link> */}
      </div>
    </div>
  );
}

export default Podcast;
